import React from 'react'
import styled from 'styled-components'
import { ICONS } from './icons'
import { MediaTitle } from 'components/media/media.styled'
import { useDispatch } from 'react-redux'
import { setUploadVideoType, setViewUploadVideoModal } from 'features/videos/videoSlice'
import { Tooltip } from '@mui/material'
import { pBtn } from 'components/main.styled'
import { useTranslation } from 'react-i18next'

const videoTypes = [
    {
        type: 'youtube',
        name: 'Youtube',     
        color: "red",
        tooltipKey: 'videoSources.youtubeTooltip',
        descriptionKey: 'videoSources.youtubeDescription',
    },
    {
        type: 'computer',
        name: 'My Computer', 
        color: "#cccccc",
        tooltipKey: 'videoSources.computerTooltip',
        descriptionKey: 'videoSources.computerDescription',
    },
    {
        type: 'url',
        name: 'Video from URL',
        color: "#375288",
        tooltipKey: 'videoSources.urlTooltip',
        descriptionKey: 'videoSources.urlDescription',
    }

]

export default function VideoUploadSelect() {
    const { t } = useTranslation('media')

    const dispatch = useDispatch()
    const [ currentSelection, setCurrentSelection ] = React.useState(null)

    const handleClick = (type) => {
        // dispatch(setUploadVideoType(type))
        // dispatch(setViewUploadVideoModal(true))1
        setCurrentSelection(type)
    }

    const handleNext = () => {
        dispatch(setUploadVideoType(currentSelection))
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: '100%',
        }}>
            <div>
                <MediaTitle>{t('selectVideoSource')}</MediaTitle>
                <VideoUploadSelectContainer> 
                    {
                        videoTypes.map((videoType, index) => (
                            
                            <Tooltip title={t(videoType.tooltipKey)} placement='top' >
                                <ItemType
                                    key={index}
                                    onClick={() => handleClick(videoType.type)}
                                    isSelected={currentSelection === videoType.type} 
                                    svgColor={videoType.color}
                                    >
                                    {ICONS[videoType.type]}
                                </ItemType>
                            </Tooltip>
                        ))
                    } 
                </VideoUploadSelectContainer>

                { currentSelection &&
                    <div style={{marginTop: '20px', fontSize: '14px', color: '#9a9a9a', marginBottom: '10px'}}>
                        {t(videoTypes.find(v => v.type === currentSelection).descriptionKey)}
                    </div>
                }                
            </div>

            { currentSelection &&       
                <div style={{marginTop: '40px', display: 'flex', justifyContent: 'flex-end'}}>
                    <StyledSubmitButton
                        onClick={handleNext}
                        >       
                        {t('next')}
                    </StyledSubmitButton>
                </div>
            }
        </div>

    )
}

const StyledSubmitButton = styled(pBtn)`
    padding: 10px 20px;
    background-color: var(--themeColor);       
    color: white;
`

const VideoUploadSelectContainer = styled.div`
    width: 100%;
    height: fit-content; 
    display: flex;
    flex-direction: row;
    align-items: center; 
    margin-top: 10px;
`

const ItemType = styled.div`
    width: 70px;
    height: 70px;
    background-color: white;
    border-radius: 10px;
    display: flex;
    border: ${props => props.isSelected ? `3px solid var(--themeColor)` : '3px solid transparent'};
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: var(--lightThemeFontColor);
    box-shadow: 0px 0px 10px #ccc;

    &:hover{
        cursor: pointer;
        background-color: #f5f5f5;
    }

    svg{
        width: 30px;
        height: 30px;
        fill: ${props => props.svgColor};
    }
`
